import {
  createContext,
  createElement,
  useEffect,
  useState,
} from 'react'

import {
  ContextProps,
  ContextProviderProps,
} from './types'

const defaultIsLoaded = false

export const GoogleMapsContext = createContext<ContextProps>({ isLoaded: defaultIsLoaded })

const scriptSrc = `https://maps.googleapis.com/maps/api/js?key=${process.env.RAZZLE_GOOGLE_API_KEY}&libraries=places`

export const GoogleMapsContextProvider: React.FC<ContextProviderProps> = ({ children }): React.ReactElement => {
  const [
    isLoaded,
    setIsLoaded,
  ] = useState(defaultIsLoaded)

  useEffect(() => {
    const existingScripts = Array.from(document.scripts).filter(script => script.src.match(/^http[s]?:\/\/maps\.googleapis\.com/))

    if (existingScripts.length) {
      setIsLoaded(true)

      return () => undefined
    }

    const script = document.createElement('script')
    script.src = scriptSrc
    script.async = true
    script.onload = () => setIsLoaded(true)

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return createElement(
    GoogleMapsContext.Provider,
    { value: { isLoaded } },
    children,
  )
}
